export default __webpack_public_path__ + "d32b9989549aec3b7ad04a961cc043b0.png";